export default class imageCropTool {
    constructor(id, element, asset_id, csrf_token, fileUpdated, showLoader, hideLoader, width, height) {
        this.id = id;
        this.asset_id = asset_id;
        this.element = element;
        this.fileUpdated = fileUpdated;
        this.showLoader = showLoader;
        this.hideLoader = hideLoader;
        this.options = {letterboxColour : '#666666'};
        this.csrf_token = csrf_token;
        this.element.imageCropper = this;
        // TODO: update from options passed in.
        this.element.insertAdjacentHTML('beforeend',
           `<div id="img-wrapper${this.id}" style="text-align:center;">
                <div id="img-crop-frame${this.id}" style="box-sizing:content-box;margin: auto;position:relative;">
                    <img id="imgframe-${this.id}" />
                    <div class="img-crop-frame-opacity" style="opacity:0.5;background-color:#777;position:absolute;top:0;bottom:0;left:0;right:0;"></div>
                    <div id="img-crop-wrapper${this.id}">
                        <img id="img-${this.id}" />
                    </div>
                </div>
                <div id="img-controls${this.id}" style="display:none; text-align:center;">
                <div class="zoom-slider">
                    <span class="zoom-out zoom-control">-</span>
                    <span class="zoom-slide" style="position:relative;display:block;width:100%;height:100%; margin:0 10px;"><span class="slide-handle"></span></span>
                    <span class="zoom-in zoom-control">+</span>
                </div>
                <a class="btn btn-default do-crop" href="#">Crop</a></div>
                <div id="img-info${this.id}"></div>
            </div>`
        );
        this.wrapper = document.getElementById('img-wrapper' + this.id);
        this.imgcropwrapper = document.getElementById('img-crop-wrapper' + this.id);
        this.imgframe = document.getElementById('imgframe-' + this.id);
        this.imgcropframe = document.getElementById('img-crop-frame' + this.id);
        this.img = document.getElementById('img-' + this.id);
        this.imgcontrols = document.getElementById('img-controls' + this.id);
        this.img.addEventListener('load', this.calculateImageZoom.bind(this));
        this.img.addEventListener('error', this.loadImageError.bind(this));
        let zoomslider = this.wrapper.querySelector(".zoom-slider");
        zoomslider.style.background = 'rgba(0, 0, 0, 0.5)';
        zoomslider.style.borderRadius = "15px";
        zoomslider.style.padding = "0 32px";
        zoomslider.style.height = "29px";
        zoomslider.style.maxWidth = "300px";
        zoomslider.style.margin = "20px auto";
        zoomslider.style.position = "relative";

        let zoomcontrols = Array.from(this.wrapper.querySelectorAll(".zoom-control"));
        zoomcontrols.map((zoomcontrol) => {
            zoomcontrol.style.cursor = "pointer";
            zoomcontrol.style.position = 'absolute';
            zoomcontrol.style.top = '5px';
            zoomcontrol.style.width ='32px';
            zoomcontrol.style.height = '32px';
        });
        
        let zoomOut = this.wrapper.querySelector(".zoom-out");
        zoomOut.style.left = '5px';
        zoomOut.addEventListener('click', this.zoomOut.bind(this));

        let zoomIn = this.wrapper.querySelector(".zoom-in");
        zoomIn.style.right = '5px';
        zoomIn.addEventListener('click', this.zoomIn.bind(this));

        let slideHandle = this.slidehandle = this.wrapper.querySelector(".slide-handle");        
        slideHandle.style.background = '#fff';
        slideHandle.style.borderRadius = '6px';
        slideHandle.style.top = '8px';
        slideHandle.style.height = '13px';
        slideHandle.style.marginLeft = '-6px';
        slideHandle.style.width = '13px';
        slideHandle.style.cursor = 'move';
        slideHandle.style.position = 'absolute';

        this.zoomslide = zoomslider.querySelector('.zoom-slide');
        this.zoomslide.addEventListener('mousedown', this.slideMouseDown.bind(this));
        this.zoomslide.addEventListener('mousemove', this.slideMouseMove.bind(this));


        this.imginfo = document.getElementById('img-info' + this.id);
        //this.init();
        this.showLoader();
        this.setSize(width, height, true);
    }
    setImage(img_src, asset_id){
        this.asset_id=asset_id;
        this.img.src = img_src;
        this.imgframe.src = img_src;
    }
    
    setZoom(zoom){
        let new_image_zoom = Math.min(Math.max(zoom, this.minimum_zoom), 1);
        this.image_zoom = new_image_zoom;
        this.zoom_width = this.image_width * this.image_zoom;
        this.zoom_height = this.image_height * this.image_zoom;
        this.padding_width = Math.max((this.target_width - this.zoom_width) / 2, 0);
        this.padding_height = this.padding_height = Math.max((this.target_height - this.zoom_height) / 2, 0);
        this.img.style.width = this.zoom_width + 'px';
        this.img.style.height =  this.zoom_height + 'px';
        this.img.style.padding = this.padding_height + 'px ' + this.padding_width + 'px';
        this.imgframe.style.width = this.zoom_width + 'px';
        this.imgframe.style.height = this.zoom_height + 'px';
        this.imgframe.style.padding = this.padding_height + 'px ' + this.padding_width + 'px';
        this.setPosition(parseInt(this.img.style.left), parseInt(this.img.style.top));
        this.slidehandle.style.left = ((new_image_zoom - this.minimum_zoom) / this.slider_scale * 100) + '%'
    }
    zoomOut(){
        this.setZoom(this.image_zoom - 0.01)
    }
    zoomIn(){
        this.setZoom(this.image_zoom + 0.01)
    }

    slideMouseDown(e) {
        e.preventDefault(); //some browsers do image dragging themselves
        this.mouse_down_slider = true;
        this.mouse_down_slider_coords = {
            x: e.pageX,
            y: e.pageY
        };
        //console.log("oldleft:" + this.slidehandle.style.left);
        this.mouse_down_slide_position = {
            x:parseInt(this.slidehandle.style.left) //Position in percent
        };
        //this.slideMouseMove(e);
    }
    slideMouseMove(e) {
        if (this.mouse_down_slider) {
            let xDif = (e.pageX - this.mouse_down_slider_coords.x); //Difference in pixels.
            //console.log(xDif);
            let newLeft = this.mouse_down_slide_position.x + (xDif/this.zoomslide.offsetWidth*100);
            newLeft = Math.max(newLeft, 0);
            newLeft = Math.min(newLeft, 100);
            //console.log("newleft:"+newLeft);
            this.setZoom(((newLeft/100) * this.slider_scale) + this.minimum_zoom);
        }
    }
    handleMouseUp(){
        this.mouse_down_slider = false;
        this.mouse_down = false;
    }
    
    removeFile() {
        this.img.removeAttribute('src')
        this.img.style.width = "";
        this.img.style.height ="";
        this.imgframe.removeAttribute('src')
        this.imgframe.style.width = "";
        this.imgframe.style.height ="";
        this.imginfo.innerHTML = 'Image removed';
        this.imgcontrols.style.display = "none";
    }

    setSize(width, height, initial) {
        if (initial === undefined)
            initial = false;
        //update image cropper size.
        this.target_width = width;
        this.target_height = height;
        document.documentElement.removeEventListener('mousemove', this.handleMouseMove.bind(this));
        this.img.removeEventListener('mousedown', this.handleMouseDown.bind(this));
        window.removeEventListener('mouseup', this.handleMouseUp.bind(this));
        
        this.img.removeEventListener('mousewheel', this.handleScroll.bind(this));
        this.img.removeEventListener('DOMMouseScroll', this.handleScroll.bind(this));
        this.wrapper.querySelector('.do-crop').removeEventListener('click', this.doCrop.bind(this))

        if (width && height) { //target height and target width
            let target_width = width;
            let target_height = height;

            this.imginfo.innerHTML = 'Image will be cropped to ' + target_width + 'x' + target_height + '.';
            this.imgcropframe.style.width = target_width + 'px';
            this.imgcropframe.style.height =  target_height + 'px';
            this.imgcropframe.style.overflow = 'hidden';
            this.imgcropframe.style.backgroundColor = this.options.letterboxColour;
            this.imgcropframe.style.padding = '20px';
        
            this.imgcropwrapper.style.width = target_width + 'px';
            this.imgcropwrapper.style.height = target_height + 'px';
            this.imgcropwrapper.style.position = 'relative';
            this.imgcropwrapper.style.overflow = 'hidden';
            this.imgcropwrapper.style.backgroundColor = this.options.letterboxColour;
            
            this.img.style.position = 'absolute';
            this.img.style.cursor = 'move';
            this.img.style.boxSizing = 'content-box';

            this.imgframe.style.position = 'absolute';
            this.imgframe.style.cursor = 'move',
            this.imgframe.style.boxSizing = 'content-box';

            document.documentElement.addEventListener('mousemove', this.handleMouseMove.bind(this));
            this.img.addEventListener('mousedown', this.handleMouseDown.bind(this));
            window.addEventListener('mouseup', this.handleMouseUp.bind(this));
            
            this.img.addEventListener('mousewheel', this.handleScroll.bind(this));
            this.img.addEventListener('DOMMouseScroll', this.handleScroll.bind(this));
            this.wrapper.querySelector('.do-crop').addEventListener('click', this.doCrop.bind(this))
            this.imgcropwrapper.style.display = "block";
            this.wrapper.querySelector(".img-crop-frame-opacity").style.display = "block";
            //TODO: Touch events?
        } else {
            //No crop mode.
            this.imgframe.style.position = 'static';
            this.imgframe.style.cursor = 'normal';

            this.imgcropframe.style.width = 'auto';            
            this.imgcropframe.style.height = 'auto',
            this.imgcropframe.style.padding = '';
            this.imgcropframe.style.backgroundColor = null;
            //this.imgcropframe.style.padding = '20px';
            
            // this.imgframe.style.position = 'absolute';
            // this.imgframe.style.cursor = 'move',
            // this.imgframe.style.boxSizing = 'content-box';

            this.img.style.position = 'static';
            this.img.style.cursor = 'normal';
            // this.img.style.boxSizing = 'content-box';
            
            this.imgcontrols.style.display = "none";
            this.imgcropwrapper.style.display = "none";
            this.wrapper.querySelector(".img-crop-frame-opacity").style.display = "none";
        }
        if (!initial) {
            this.calculateImageZoom()
        }
    }
    loadImageError(){
        this.hideLoader();
        //TODO: retry loading image?
        this.imginfo.innerHTML = 'Error loading image';
    }
    
    calculateImageZoom() {
        this.hideLoader();
        let image_width = this.image_width = this.img.naturalWidth;
        let image_height = this.image_height = this.img.naturalHeight;
        var target_width = this.target_width, target_height = this.target_height;

        //TODO: If image is vector does cropping make any sense?
        if (target_width && target_height) { //target height and target width
            this.imginfo.innerHTML = 'Image being cropped to ' + target_width + 'x' + target_height + '. Original size ' + image_width + 'x' + image_height + ' pixels';
            var widthRatio = target_width / image_width; //May not have a targetheight/targetwidth.
            var heightRatio = target_height / image_height;
            var fit_zoom;
            if (widthRatio <= heightRatio) {
                this.minimum_zoom = (image_width < target_width) ? (target_width / image_width) : widthRatio;
                fit_zoom = (image_height < target_height) ? (target_height / image_height) : heightRatio;
            } else {
                this.minimum_zoom = (image_height < target_height) ? (target_height / image_height) : heightRatio;
                fit_zoom = (image_width < target_width) ? (target_width / image_width) : widthRatio;
            }
            this.slider_scale = 1 - this.minimum_zoom;
            this.img.style.top = "0px";
            this.img.style.left = "0px";
            this.imgframe.style.top = "20px";
            this.imgframe.style.left = "20px";
            this.imgcontrols.style.display = "block";
            this.setZoom(fit_zoom);
            //TODO: ability to target only a height or width.
        } else {
            if (image_width && image_width > 300) {
                this.imginfo.innerHTML = 'Image scaled down. Original size ' + image_width + 'x' + image_height + ' pixels';
                this.imgframe.style.width = '300px';
                this.imgframe.style.height = 'auto';
            } else {
                this.imginfo.innerHTML = 'Image size ' + this.img.width + 'x' + this.img.height + ' pixels';
            }
        }
        this.img.style.display = "block";
    }
    
    setPosition(x,y){
        x = Math.max(Math.min((this.target_width - this.zoom_width),0) - this.padding_width, Math.min(this.padding_width, x));
        y = Math.max(Math.min((this.target_height - this.zoom_height),0) - this.padding_height, Math.min(this.padding_height, y));
        this.img.style.left = (x.toString() + 'px');
        this.img.style.top = (y.toString() + 'px');
        
        this.imgframe.style.left = ((x + 20).toString() + 'px');
        this.imgframe.style.top = ((y + 20).toString() + 'px');

    }
    handleMouseMove(e) {
        if (this.mouse_down) {
            var xDif = e.pageX - this.mouse_down_coords.x;
            var yDif = e.pageY - this.mouse_down_coords.y;
            this.setPosition(this.mouse_down_image_position.x + xDif, this.mouse_down_image_position.y + yDif);
        }
    }
    handleMouseDown(e) {
        e.preventDefault(); //some browsers do image dragging themselves
        this.mouse_down = true;
        this.mouse_down_coords = {
            x: e.pageX,
            y: e.pageY
        };
        this.mouse_down_image_position = {
            x: parseInt(this.img.style.left),
            y: parseInt(this.img.style.top)
        }
    }
    handleScroll(e) {
        e.preventDefault();
        if (e.wheelDelta > 0 || e.detail < 0) {
            this.setZoom(this.image_zoom + 0.01)
        } else {
            this.setZoom(this.image_zoom - 0.01)
        }
    }
    doCrop(e) {
        e.preventDefault();
        this.showLoader();        

        let image_position = {
            x: parseInt(this.img.style.left),
            y: parseInt(this.img.style.top)
        };
        let left_px = (-image_position.x / this.image_zoom);
        let top_px = (-image_position.y / this.image_zoom);
        let data = {
            'left_x': (left_px - (this.padding_width / this.image_zoom)) / this.image_width,
            'top_y': (top_px - (this.padding_height / this.image_zoom)) / this.image_height,
            'right_x': (left_px - (this.padding_width / this.image_zoom) + (this.target_width / this.image_zoom)) / this.image_width,
            'bottom_y': (top_px - (this.padding_height / this.image_zoom) + (this.target_height / this.image_zoom)) / this.image_height,
            'target_width': this.target_width,
            'target_height': this.target_height,
            'format': 'json'
        }

        //Ask server to crop the image
        var form_data = new FormData();
        form_data.append("_csrf_token", this.csrf_token)
        Object.keys(data).forEach(key => form_data.append(key, data[key]));
        fetch(`/console/resize-image-asset/${encodeURIComponent(this.asset_id)}`,{
            body:form_data,
            method: 'post',
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
        })
        .then((response)=> {
            if (!response.ok) {
                throw Error("Could not process image. Please check that the file is a valid image, or try a smaller image.")
            }
            return response;
        })
        .then((response)=>response.json())
        .then((response)=>{
            if (response.error) {
                alert(response.error);
                this.hideLoader();
            } else {
                this.fileUpdated(response.asset_id);
                this.setImage(response.asset_url, response.asset_id);
            }
        }, (error)=> {            
            alert(error);
            this.hideLoader();
        });
    }
}
